/*
 * Copyright (c) 2025, Wultra s.r.o. (www.wultra.com).
 *
 * All rights reserved. This source code can be used only for purposes specified
 * by the given license contract signed by the rightful deputy of Wultra s.r.o.
 * This source code can be used only by the owner of the license.
 *
 * Any disputes arising in respect of this agreement (license) shall be brought
 * before the Municipal Court of Prague.
 */

import { useReactAppContext } from "../../app-context"
import type { EventBus } from "../../event-bus/event-bus"
import type { AppState } from "../../features/app/app-state"
import type { LoggerStore } from "../../logger/logger-store"
import type { Constructor, ViewModel, ViewModelContainer } from "../../viewmodel/viewmodel"

export const useEventBus = (): EventBus => useReactAppContext().eventBus

export const useAppState = (): AppState => useReactAppContext().appState

export const useLoggerStore = (): LoggerStore => useReactAppContext().loggerStore

export const useViewModelContainer = (): ViewModelContainer => useReactAppContext().vmContainer

export const useViewModel = <T extends ViewModel>(viewModelClass: Constructor<T>): T =>
    useViewModelContainer().getViewModel(viewModelClass)

// `args` are the arguments of the factory registered for this class, not of its
// constructor — the two differ, and the container pairs them only at runtime, so
// they cannot be checked here.
export const useViewModelWithArgs = <T extends ViewModel>(viewModelClass: Constructor<T>, ...args: unknown[]): T =>
    useViewModelContainer().getViewModel(viewModelClass, ...args)
